var scope_0 = require('/opt/build/repo/monodocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0b4b2627e21cf59fca09a5d12f205ae4.js').default;
var scope_1 = require('/opt/build/repo/monodocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/60505b4731625cabf1ad6ffee0e967d9.js').default;
var scope_2 = require('/opt/build/repo/monodocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    